import styled from 'styled-components'

import { Section as SectionDS } from 'components/general-styles/General'
import { theme } from 'styles/theme'

const { colors, space, radii } = theme

export const Section = styled(SectionDS)`
  h2 {
    margin-top: ${space['spacing-md']};
    margin-bottom: ${space['spacing-md']};
  }
`
export const CardWrapper = styled.div`
  border: 1px solid ${colors['neutral-border-pressed']};
  border-radius: ${radii['corner-radius-md']};
  padding: ${space['spacing-md']};
  height: 100%;

  p {
    margin-bottom: ${space['spacing-sm']};
  }
  
  p:first-of-type {
    margin-top: ${space['spacing-sm']};
  }
`
